import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { canAccessSuperAdminRoutes } from 'src/utils/permitFeatureAccess';

type SuperAdminRouteProps = {
  element: ReactElement;
};

const SuperAdminRoute: FC<SuperAdminRouteProps> = ({ element }) => {
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  if (!canAccessSuperAdminRoutes(userDetails)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default SuperAdminRoute;
